module.exports = __webpack_public_path__ + "fonts/HELVETICA_LT_CONDENSED_MEDIUM.2b4a2b9a.ttf";